/**
 * Best-effort public IP of the user's network (what the internet sees).
 * Browsers cannot read LAN/private NIC addresses; this is the practical substitute for "computer IP" in a web app.
 */
const STORAGE_KEY = 'ainsoft_client_public_ip';

let memory = '';

function readCache() {
  if (memory) return memory;
  try {
    memory = sessionStorage.getItem(STORAGE_KEY) || '';
  } catch {
    memory = '';
  }
  return memory;
}

function writeCache(ip) {
  memory = ip || '';
  try {
    if (memory) sessionStorage.setItem(STORAGE_KEY, memory);
  } catch {
    /* ignore */
  }
}

/** Synchronous value for request headers (empty until resolved). */
export function getClientPublicIpSync() {
  return readCache();
}

let inflight = null;

/**
 * Resolve once per tab session and cache. Safe to call multiple times.
 * @returns {Promise<string>}
 */
export function initClientPublicIp() {
  if (readCache()) return Promise.resolve(readCache());
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const res = await fetch('https://api.ipify.org?format=json', { cache: 'no-store' });
      if (!res.ok) throw new Error(String(res.status));
      const j = await res.json();
      const ip = (j && j.ip ? String(j.ip) : '').trim();
      if (ip) writeCache(ip);
    } catch {
      try {
        const res2 = await fetch('https://api64.ipify.org?format=json', { cache: 'no-store' });
        if (res2.ok) {
          const j2 = await res2.json();
          const ip2 = (j2 && j2.ip ? String(j2.ip) : '').trim();
          if (ip2) writeCache(ip2);
        }
      } catch {
        /* leave empty */
      }
    } finally {
      inflight = null;
    }
    return readCache();
  })();
  return inflight;
}
